import { API_BASE } from "@/lib/api";

export function conversationTitle(conversation, currentUserId) {
  if (!conversation) return "Mensagens";
  if (conversation.type === "group") return conversation.name || "Grupo";
  const other = (conversation.participants || []).find((p) => p.id !== currentUserId);
  return other?.name || "Conversa direta";
}

export function roleLabel(role) {
  return ({ admin: "Admin", medico: "Médico", enfermeira_prescritora: "Enfermeira | Tricologia", secretaria: "Secretaria", enfermagem: "Enfermagem" }[role] || role);
}

export function timeLabel(value) {
  if (!value) return "";
  try {
    return new Date(value).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  } catch (_) {
    return "";
  }
}

export function chatFileUrl(fileId) {
  const token = localStorage.getItem("kloss_token") || "";
  return `${API_BASE}/chat/files/${fileId}/download?auth=${encodeURIComponent(token)}`;
}

export function formatBytes(size) {
  const n = Number(size || 0);
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}